import { URL_POST_USER_LOGOUT } from "@/requests/user";
import MockAdapter from "axios-mock-adapter/types";

export const logoutMock = (mock: MockAdapter): void => {
  mock.onPost(URL_POST_USER_LOGOUT).reply(() => {
    return [200];
  });
};
